import React from 'react';

const DropArea = ({ dropAreaType, onClick, rest }) => {
	return (
		<div
			onClick={onClick}
			{...rest}
			className={`d-flex justify-content-center align-items-center dropArea ${dropAreaType}`}>
			<div className='text-center'>
				<i className='fas fa-cloud-upload-alt'></i>
			</div>
		</div>
	);
};

export default DropArea;
